import { appCached, appCachedKeys } from '../../appCached';

export const actionTypes = {
	HOCSINH_LOAD_BEGIN: 'BEGIN_LOAD_HOCSINH',
	HOCSINH_LOAD_SUCCESS: 'SUCCESS_LOAD_HOCSINH',
	HOCSINH_LOAD_ERR: 'ERROR_LOAD_HOCSINH',

	CHANGE_HOCSINH_EDITING: 'CHANGE_EDITING_HOCSINH',
	CHANGE_HOCSINH_SELECTED_IDS: 'CHANGE_SELECTED_HOCSINH_IDS',
	CHANGE_FILTER: 'CHANGE_FILTER',

	SHOW_DETAIL_MODAL: 'SHOW_DETAIL_MODAL',
	CLOSE_DETAIL_MODAL: 'CLOSE_DETAIL_MODAL',

	SHOW_CHANGE_STATUS_MODAL: 'SHOW_CHANGE_STATUS_MODAL',
	CLOSE_CHANGE_STATUS_MODAL: 'CLOSE_CHANGE_STATUS_MODAL',

	SHOW_GROUP_HS_MODAL: 'SHOW_GROUP_HS_MODAL',
	CLOSE_GROUP_HS_MODAL: 'CLOSE_GROUP_HS_MODAL',

	SHOW_DELETE_CONFIRM: 'SHOW_DELETE_CONFIRM',
	CLOSE_DELETE_CONFIRM: 'CLOSE_DELETE_CONFIRM',

	SHOW_GAN_KHOAN_PHI_MODAL: 'SHOW_GAN_KHOAN_PHI_MODAL',
	CLOSE_GAN_KHOAN_PHI_MODAL: 'CLOSE_GAN_KHOAN_PHI_MODAL',

	SHOW_IMPORT_MODAL: 'SHOW_IMPORT_MODAL',
	CLOSE_IMPORT_MODAL: 'CLOSE_IMPORT_MODAL',

	SHOW_IMPORT_LOP_MODAL: 'SHOW_IMPORT_LOP_MODAL',
	CLOSE_IMPORT_LOP_MODAL: 'CLOSE_IMPORT_LOP_MODAL',

	SHOW_LEN_LOP_MODAL: 'SHOW_LEN_LOP_MODAL',
	CLOSE_LEN_LOP_MODAL: 'CLOSE_LEN_LOP_MODAL',

	SHOW_GAN_NGAY_NHAP_HOC_MODAL: 'SHOW_GAN_NGAY_NHAP_HOC_MODAL',
	CLOSE_GAN_NGAY_NHAP_HOC_MODAL: 'CLOSE_GAN_NGAY_NHAP_HOC_MODAL',
};
export const hocSinhPageStastus = {
	isLoading: '',
	isCompleted: 'isCompleted',
	isSaving: 'isSaving',
};
export const hocSinhIniState = {
	hocSinhs: [],
	status: hocSinhPageStastus.isCompleted,
	hocSinhEditing: { id: 0 },
	hocSinhSelectedIds: [],
	isShowDetailModal: false,
	isShowChangeStatusModal: false,
	isShowGroupHsModal: false,
	isShowGanKhoanPhiModal: false,
	isShowGanNgayNhapHocModal: false,
	isShowDeleteConfirm: false,
	isShowImportModal: false,
	isShowImportLopModal: false,
	isShowLenLopModal: false,
	filter: {
		namHoc: '',
		truongSelectedId: 0,
		searchKey: '',
		dm_trangthaihocsinh_ids: [],
	},
};
export const hocSinhReducer = (state, action) => {
	switch (action.type) {
		case actionTypes.HOCSINH_LOAD_BEGIN:
			return {
				...state,
				status: hocSinhPageStastus.isLoading,
			};
		case actionTypes.HOCSINH_LOAD_SUCCESS:
			return {
				...state,
				hocSinhs: action.payload,
				status: hocSinhPageStastus.isCompleted,
			};
		case actionTypes.HOCSINH_LOAD_ERR:
			return {
				...state,
				hocSinhs: [],
				status: hocSinhPageStastus.isCompleted,
			};
		case actionTypes.CHANGE_HOCSINH_EDITING:
			return {
				...state,
				hocSinhEditing: action.payload,
			};
		case actionTypes.CHANGE_HOCSINH_SELECTED_IDS:
			return {
				...state,
				hocSinhSelectedIds: action.payload,
			};
		case actionTypes.CHANGE_FILTER:
			return {
				...state,
				filter: action.payload,
			};
		case actionTypes.SHOW_DETAIL_MODAL:
			return {
				...state,
				isShowDetailModal: true,
				hocSinhEditing: action.payload,
			};
		case actionTypes.CLOSE_DETAIL_MODAL:
			return {
				...state,
				isShowDetailModal: false,
				hocSinhEditing: { id: 0 },
			};
		case actionTypes.SHOW_CHANGE_STATUS_MODAL:
			return {
				...state,
				isShowChangeStatusModal: true,
			};
		case actionTypes.CLOSE_CHANGE_STATUS_MODAL:
			return {
				...state,
				isShowChangeStatusModal: false,
			};
		case actionTypes.SHOW_GROUP_HS_MODAL:
			return {
				...state,
				isShowGroupHsModal: true,
			};
		case actionTypes.CLOSE_GROUP_HS_MODAL:
			return {
				...state,
				isShowGroupHsModal: false,
			};
		case actionTypes.SHOW_DELETE_CONFIRM:
			return {
				...state,
				isShowDeleteConfirm: true,
			};
		case actionTypes.CLOSE_DELETE_CONFIRM:
			return {
				...state,
				isShowDeleteConfirm: false,
			};
		case actionTypes.SHOW_GAN_KHOAN_PHI_MODAL:
			return {
				...state,
				isShowGanKhoanPhiModal: true,
			};
		case actionTypes.CLOSE_GAN_KHOAN_PHI_MODAL:
			return {
				...state,
				isShowGanKhoanPhiModal: false,
			};
		case actionTypes.SHOW_IMPORT_MODAL:
			return {
				...state,
				isShowImportModal: true,
			};
		case actionTypes.CLOSE_IMPORT_MODAL:
			return {
				...state,
				isShowImportModal: false,
			};
		case actionTypes.SHOW_IMPORT_LOP_MODAL:
			return {
				...state,
				isShowImportLopModal: true,
			};
		case actionTypes.CLOSE_IMPORT_LOP_MODAL:
			return {
				...state,
				isShowImportLopModal: false,
			};
		case actionTypes.SHOW_LEN_LOP_MODAL:
			return {
				...state,
				isShowLenLopModal: true,
			};
		case actionTypes.CLOSE_LEN_LOP_MODAL:
			return {
				...state,
				isShowLenLopModal: false,
			};
		case actionTypes.SHOW_GAN_NGAY_NHAP_HOC_MODAL:
			return {
				...state,
				isShowGanNgayNhapHocModal: true,
			};
		case actionTypes.CLOSE_GAN_NGAY_NHAP_HOC_MODAL:
			return {
				...state,
				isShowGanNgayNhapHocModal: false,
			};
		default:
			return state;
	}
};
